import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';

export type MenuPopupSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'kt-menu-popup',
  templateUrl: './menu-popup.component.html',
  styleUrls: ['./menu-popup.component.scss']
})
export class MenuPopupComponent {
  /** Width variant: sm = 280px, md = 420px, lg = 560px */
  @Input() size: MenuPopupSize = 'md';

  @HostBinding('class') get sizeClass(): string {
    return `kt-menu-popup--${this.size}`;
  }
  /** Icon shown in the header (Material Symbols name) */
  @Input() icon: string = '';
  /** Title text shown in the header */
  @Input() title: string = '';
  /** Label for the confirm button */
  @Input() confirmLabel: string = 'Confirm';
  /** Label for the cancel button */
  @Input() cancelLabel: string = 'Cancel';
  /** Theme for the confirm button: 'primary' | 'danger' | 'success' */
  @Input() confirmTheme: 'primary' | 'danger' | 'success' = 'primary';
  /** Disables the confirm button */
  @Input() confirmDisabled: boolean = false;
  /** Hides the footer (cancel + confirm) entirely */
  @Input() hideFooter: boolean = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm() {
    this.confirmed.emit();
  }

  onCancel() {
    this.cancelled.emit();
  }
}
